import { render } from "./syndromeSelector.vue?vue&type=template&id=3298bf31&scoped=true"
import script from "./syndromeSelector.vue?vue&type=script&lang=js"
export * from "./syndromeSelector.vue?vue&type=script&lang=js"

import "./syndromeSelector.vue?vue&type=style&index=0&id=3298bf31&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3298bf31"]])

export default __exports__